// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__8nq_L","white":"Button_white__Rw5SK","notRounded":"Button_notRounded__2HDQk","visHid":"Button_visHid__7yZW5","outline":"Button_outline__gjP1Z"};